import { render, staticRenderFns } from "./ForemanStatusFieldComponent.vue?vue&type=template&id=04e5677d&"
import script from "./ForemanStatusFieldComponent.vue?vue&type=script&lang=js&"
export * from "./ForemanStatusFieldComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04e5677d')) {
      api.createRecord('04e5677d', component.options)
    } else {
      api.reload('04e5677d', component.options)
    }
    module.hot.accept("./ForemanStatusFieldComponent.vue?vue&type=template&id=04e5677d&", function () {
      api.rerender('04e5677d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/components/fields/ForemanStatusFieldComponent.vue"
export default component.exports